import React from "react";
import {
  WhatsappShareButton,
  WhatsappIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  TelegramShareButton,
  TelegramIcon,
  PinterestShareButton,
  PinterestIcon,
} from "react-share";
import win from "../../lib/win_util";

export default ({ node }) => {
  let currentUrl = "";
  if (win) {
    currentUrl = window.location.href;
  }
  const { sharing, kind } = node;
  let shareButton = "";
  let isRound = kind == "Square" ? false : true;
  switch (sharing) {
    case "Whatsapp":
      shareButton = (
        <WhatsappShareButton url={currentUrl}>
          <WhatsappIcon size={32} round={isRound} />
        </WhatsappShareButton>
      );
      break;
    case "FB":
      shareButton = (
        <FacebookShareButton url={currentUrl}>
          <FacebookIcon size={32} round={isRound} />
        </FacebookShareButton>
      );
      break;
    case "Twitter":
      shareButton = (
        <TwitterShareButton url={currentUrl}>
          <TwitterIcon size={32} round={isRound} />
        </TwitterShareButton>
      );
      break;
    case "Telegram":
      shareButton = (
        <TelegramShareButton url={currentUrl}>
          <TelegramIcon size={32} round={isRound} />
        </TelegramShareButton>
      );
      break;
    case "Pinterest":
      shareButton = (
        <PinterestShareButton url={currentUrl} media={"/favicon.png"}>
          <PinterestIcon size={32} round={isRound} />
        </PinterestShareButton>
      );
      break;
  }
  return <span style={{ marginRight: "5px" }}>{shareButton}</span>;
};
